<template>
    <div id="manage">
        <div class="content">
            <div class="title">作业管理</div>
            <div class="top">
                <div class="fl_left">
                    <div class="wzbarBox">
                        <div class="wzbar" v-for="(item,index) in danceList" @click="changeDance(item)"
                            :class="{'wzbars':item.id == searchModel.dance_id}">
                            <div>{{item.name}}</div>
                            <span></span>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
            <div class="top">
                <div class="fl_left">
                    <div class="wzbarBox">
                        <div class="wzbar" v-for="(item,index) in items" @click="changeLevel(item)"
                            :class="{'wzbars':item.id == searchModel.level_id}">
                            <div>{{item.name}}</div>
                            <span></span>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
            <div class="botBox">
                <div class="bottomBox">
                    <div class="selVox">
                        <div class="fl_right addClass" @click="addWork">添加{{addWorkModel.tag}}作业</div>
                    </div>
                    <div class="bottom" style="border:1px solid #e6e6e6;box-sizing: border-box;">
                        <Table :columns="columns7" :data="data6" :loading="loading" :draggable="true" @on-drag-drop="setWorkSort"></Table>
                        <Page :page-size="pageSize" :total="total" show-total :current="searchModel.page" @on-change="updatePage"
                            style="position:absolute;bottom:20px;left:38%;"></Page>
                    </div>
                </div>
                <div class="alertBox" v-if="alertShow" style="padding-top:3%;">
                    <div class="tanchuan" style="overflow: hidden;">
                        <div class="tantop">
                            <div class="fl_left tantitle">{{valm==1?'编辑':'新增'}}</div>
                            <div class="fl_right tandel" @click="tandel"></div>
                            <div class="clear"></div>
                        </div>
                        <div style="height:80vh;">
                            <div class="tancenter" style="overflow-y:auto;height: 100%;padding-bottom: 30px;">
                                
                                <div class="list listpad">
                                    <div class="fl_left name">作业名称<span
                                            style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                                    <div class="fl_left ">
                                        <Input v-model="addWorkModel.name" class="bordiv" size="large" autocomplete="off"
                                            style="width:440px;" placeholder="请输入作业名称" />
                                        <input type="text" autocomplete="off" name="" style="display:none">
                                    </div>
                                    <div class="clear"></div>
                                </div>
                                <div class="list listpad">
                                    <div class="fl_left name">作业描述</div>
                                    <div class="fl_left ">
                                        <Input v-model="addWorkModel.introduction" class="bordiv" :autosize="{minRows: 3}" resize
                                            type="textarea" placeholder="请输入" style="width: 440px;height:auto" />
                                        <input type="text" autocomplete="off" name="" style="display:none">
                                    </div>
                                    <div class="clear"></div>
                                </div>
                                <div class="list listpad">
                                    <div class="fl_left name">作业图片</div>
                                    <div class="fl_left file-list">
                                        <!-- <div class="file-list"> -->
                                            <div class="fl_left" style="padding-top: 15px;">
                                                <div class="vue-oss-imgsrc fl_left" v-for="(value,key) in imgUrls">
                                                    <img :src="value" alt="">
                                                    <div class="marksd" @click="delImg(key)"></div>
                                                </div>
                                                <div class="urlLogo urlLogo1 fl_left">
                                                    <div class="add"></div>
                                                    <!-- <img src="static/imgs/up_zjz.png" alt="" v-if="!logo"> -->
                                                    <input type="file" accept="image/jpg,image/jpeg,image/png,image/bmp"
                                                        id="file2" @change="doUpload(2)" />
                                                </div>
                                                <div class="clear"></div>
                                            </div>
                                        <!-- </div> -->
                                    </div>
                                    <div class="clear"></div>
                                </div>
                                <div class="list listpad">
                                    <div class="fl_left name">作业音乐</div>
                                    <div class="fl_left file-list">
                                        <!-- <div class="file-list"> -->
                                            <div class="fl_left">
                                                <div class="miuse_tit fl_left dan_btn" @click="play($event,0)" v-if="addWorkModel.music">
                                                    <!-- <span>{{audio_name}}</span> -->
                                                    <em>{{addWorkModel.music}}</em>
                                                    <div class="dele_music" @click="dele_mus($event,0)"></div>
                                                </div>
                                                <div class="miuse_tep fl_left" v-else>
                                                    <div class=""> + 添加音乐</div>
                                                    <!-- <img src="static/imgs/up_zjz.png" alt="" v-if="!logo"> -->
                                                    <input type="file"  @change="doUpload(3)"  id="file3" accept="audio/mp3">
                                                </div>
                                                <div class="clear"></div>
                                            </div>
                                        <!-- </div> -->
                                    </div>
                                    <div class="clear"></div>
                                </div>
                                <div class="list listpad">
                                    <div class="fl_left name">作业视频</div>
                                    <div class="fl_left file-list">
                                        <!-- <div class="file-list"> -->
                                            <div class="fl_left" style="padding-top: 15px;">
                                                <div class="vue-oss-imgsrc fl_left" v-if="addWorkModel.video">
                                                    <video controls style="width:150px ;height:150px;" :src="videoUrls"></video>
                                                    <div class="marksd" @click="delVideo()"></div>
                                                </div>
                                               
                                                <div class="urlLogo urlLogo1 fl_left" v-else>
                                                    <div class="add"></div>
                                                    <!-- <img src="static/imgs/up_zjz.png" alt=""> -->
                                                    <input type="file" accept="video/mp4" id="file4" @change="doUpload(4)" name="file"/>
                                                </div>
                                                <div class="clear"></div>
                                            </div>
                                        <!-- </div> -->
                                    </div>
                                    <div class="clear"></div>
                                </div>
                                <div class="tanBtn" @click="saveWork(valm)">确定</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="video_wrap" style="opacity: 0;">
                <div class="video_b fl_left" @click="player" v-model="psop"></div>
                <div class="video_con fl_left">
                    <div class="miuse_top">
                        <div class="mus_TB">
                            <div class="mus_tit fl_left">音乐名称</div>
                            <div class="mus_time fl_right">
                                <span class="starttime">00:00</span> /
                                <span class="endtime">00:00</span>
                            </div>
                            <div class="audis_wrap">
                                <audio :src="musicPlay" class="audis" id="audis"></audio>
                            </div>
                            <div class="fixclear"></div>
                        </div>
                        <div class="mus_bar">
                            <b class="progress-bar" :style="{width:proBar+'%'}"></b>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Spin fix v-if="spinShow">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>上传中</div>
        </Spin>
    </div>
</template>
<style>
    
</style>
<script>
    export default {
        name: 'manage',
        data() {
            return {
                spinShow:false,
                psop:0,
                proBar:'',
                musicPlay:'',
                unpUrl:strUrl + 'uploadvediocover',
                upHeader:{},
                videoFlag: false,
                //是否显示进度条
                videoUploadPercent: "",
                //进度条的进度，
                isShowUploadVideo: false,
                //显示上传按钮
                videoForm: {
                    showVideoPath: ''
                },
                // 
                FileUrls: [],
                imgUrlEd: [],
                imgUrls: [],
                videoUrls: '',
                // 
                imgd1: '',
                file_url1: '',
                cropShow: false,
                option: {
                    img: '',//剪切图片地址
                    size: 1,//输出图片压缩比默认为1
                    full: false,//输出截图是否缩放
                    outputType: 'jpg',//输出图片格式
                    canMove: true,//是否可以拖动图片
                    fixedBox: true,//是否固定截图大小
                    original: false,//上传图片按原始比例
                    canMoveBox: false,//是否可以拖动截图框
                    autoCrop: true,//是否自成截图框
                    // 只有自动截图开启 宽度高度才生效
                    autoCropWidth: 300,//截图框宽
                    autoCropHeight: 300,//截图框高
                    centerBox: false,//截图框能否超过图片
                    high: true//是否根据dpr输出高清图片
                },
                province: '',
                city: '',
                maxnum: '',
                provinceArr: [],
                cities: [],
                address: '',
                lxname: '',
                lxphone: '',
                email: '',
                scity: '',
                scityList: [],
                num: 0,
                items: [],
                tabId: 0,
                total: null,
                pageSize: 200,
                loading: false,
                stop_reason: '',
                columns7: [
                    {
                        title: '',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Icon', {
                                    props: {
                                        type: 'ios-move'
                                    },
                                    style:{
                                      cursor: 'all-scroll'
                                    }
                                })
                            ])
                        }
                    },
                    {
                        title: '序号',
                        type: 'index',
                        align: 'center',
                        width: 80
                    },
                    {
                        title: '作业名称',
                        align: 'center',
                        key: 'name'
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'bespeak_count',
                        width:200,
                        render: (h, params) => {
                            // if(params.row.status==0){
                            return h('div', [
                                
                                h('button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        backgroundColor: 'rgba(0,0,0,0)',
                                        border: 'none',
                                        marginRight: '10px'
                                    },
                                    on: {
                                        click: () => {
                                            let _this = this;
                                            _this.$axios.post('gettaskdetail', { task_id: params.row.task_id }).then(res => {
                                                if (res.data.code == 200) {
                                                    _this.addWorkModel = res.data.data;
                                                    _this.addWorkModel.task_id = res.data.data.id;
                                                    _this.videoUrls = res.data.data.video
                                                    _this.imgUrls = res.data.data.showimages
                                                    _this.FileUrls = res.data.data.showimages
                                                    _this.imgUrlEd = []
                                                    _this.valm = 1
                                                    _this.alertShow = true;
                                                }
                                                else {
                                                    _this.$message.error(res.data.message)
                                                }
                                            })

                                        }
                                    }
                                }, '编辑'),
                                h('button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        backgroundColor: 'rgba(0,0,0,0)',
                                        border: 'none',
                                    },
                                    on: {
                                        click: () => {
                                            let _this = this;
                                            this.$Modal.confirm({
                                                title: '提示',
                                                content: '<p>确定要删除？</p>',
                                                okText: '确定',
                                                cancelText: '取消',
                                                onOk: () => {
                                                    _this.$axios.post('deletetask', { task_id: params.row.task_id }).then(res => {
                                                        if (res.data.code == 200) {
                                                            _this.$Message.success('删除成功');
                                                            _this.getTaskList(1);
                                                        }
                                                        else {
                                                            this.$Message.error(res.data.message);
                                                        }
                                                    }).catch(function (error) {
                                                        console.log(error);
                                                    });
                                                },
                                                onCancel: () => {
                                                    // this.$Message.info('取消');
                                                }
                                            });
                                        }
                                    }
                                }, '删除'),
                            ]);
                            // }
                        }
                    }
                ],
                data6: [],
                sortData: [],
                alertShow: false,
                valm: 0,
                company_id: '',
                clnum: 1,
                audio_name:'',
                token:'',

                danceList:[],//舞种列表
                searchModel:{ //获取作业列表
                    dance_id:'',
                    level_id:'',
                    page:1,
                },
                addWorkModel:{ //添加作业模型
                    dance_id:'',
                    task_id:'',
                    name :'',
                    introduction: '',
                    showimages: [],
                    video: '',
                    video_cover:'',
                    tag_level_id: '',
                    tag: '',
                    level_id:'',
                    music:'',
                },
            }
        },
        mounted(){
            this.upHeader={
                "Authorization":localStorage.getItem('Authorization')
            }
        },
        methods: {
            getToken(file){
                let _this=this;
                _this.$axios.post('gettaskuploadtoken', {
                    name: file.name,
                    size: file.size,
                    type: 'video'
                }).then(res => {
                    if (res.data.code == 200) {
                        _this.token = res.data.data.token
                        _this.spinShow=true;
                        _this.upload_section(file, 1)
                    }
                    else {
                        _this.$message.error(res.data.message)
                    }
                }).catch(error => {
                    console.log(error)
                })
            },

            //只修改 form 和 to之间的排序
            setWorkSort(form, to) {
                form   = parseInt(form)
                to     = parseInt(to)
     
                let tmp = this.data6[form]

                //重置排序
                this.sortData   = [];
                //向上冒泡
                if(form < to) {
                    for(var i=form+1; i<=to; i++) {
                        this.data6.splice(i-1, 1, this.data6[i])
                        this.sortData.push({task_id:this.data6[i].task_id,tsort:i})
                    }
                    this.data6.splice(to, 1, tmp)
                    this.sortData.push({task_id:tmp.task_id,tsort:i})
                }
                //向下浮沉
                if(form > to) {
                    for(var i=form; i>to; i--) {
                        this.data6.splice(i, 1, this.data6[i-1])
                        this.sortData.push({task_id:this.data6[i-1].task_id,tsort:i})
                    }
                    this.data6.splice(to, 1, tmp)
                    this.sortData.push({task_id:tmp.task_id,tsort:i})
                }

                this.$axios.post('sorttask', {sort_data:this.sortData}).then(res => {
                    if (res.data.code == 200) {
                        this.$Message.success("排序成功");
                    }
                    else {
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },

            //切片上传视频 
            upload_section(file, num) {
                const _this = this;
                var blockSize = 2 * 1024 * 1024;
                var start = (num - 1) * blockSize;
                var blockNum = Math.ceil(file.size / blockSize);    //总片数
                var nextSize = Math.min(num * blockSize, file.size);   //下一片的位置
                var fileData = file.slice((num - 1) * blockSize, nextSize);   //
                _this.currentAjax = $.ajax({
                    url: strUrl + "taskvideoupload?token=" + _this.token + '&up_size=' + start,
                    type: "POST",
                    data: fileData,
                    processData: false,
                    contentType: 'application/json',
                    beforeSend: function (XMLHttpRequest) {
                        XMLHttpRequest.setRequestHeader("Authorization", localStorage.getItem('Authorization'));
                    },
                    success: function (responseText) {
                        if (responseText.code == 200) {
                            if (file.size <= nextSize) {
                                _this.spinShow=false;
                                _this.$message.success("上传成功");
                                _this.addWorkModel.video=responseText.data.video;
                                _this.addWorkModel.video_cover=responseText.data.cover;
                                return;
                            }
                            _this.upload_section(file, ++num);//递归调用
                        }
                        else if (responseText.code == 115) {
                            _this.$router.push({
                                path: '/login'
                            });
                        }
                        else {
                            _this.$message.error(responseText.data.message)
                        }
                    }
                });
            },
            play(e, key) {
                const _this = this;
                e.stopPropagation()
                _this.musicPlay=_this.addWorkModel.music;
                if(_this.oldKey===''){
                    _this.psop = 0;
                    _this.oldKey=key;
                }
                else{
                    if(_this.oldKey!=key){
                        _this.psop = 0;
                        _this.oldKey=key;
                    }
                    else{
                        // _this.psop = 0;
                        _this.oldKey=key;
                    }
                }
                _this.$nextTick(() => {
                    _this.player()

                })
            },
            player() {
                var time = document.querySelectorAll(".audis_wrap audio");
                var starttime = document.querySelector('.starttime');
                if (this.psop) {
                    $('.audis').get(0).pause();
                    this.psop = 0;
                    $('.video_b').removeClass('pause');
                } else {
                    $('.audis').get(0).play();
                    $('.video_b').addClass('pause');
                    this.psop = 1;
                    $('.audis').on('timeupdate', function () {
                        for (var i = 0; i < time.length; i++) {
                            var minutes = parseInt(time[i].currentTime / 60);
                            var seconds = Math.round(time[i].currentTime % 60);
                            if (minutes < 10) {
                                minutes = "0" + minutes;
                            }
                            if (seconds < 10) {
                                seconds = "0" + seconds;
                            }
                            $('.starttime').text(minutes + ":" + seconds);
                            this.proBar = $('.progress-bar').width((time[i].currentTime / time[i].duration) * 100 + '%')
                            if (this.proBar == 100) {
                                $('.audis').get(0).pause();
                                $('.video_b').removeClass('pause');
                                this.proBar = 0
                            }
                        }
                    });
                }
            },
            dele_mus(e, i) {
                const _this = this;
                e.stopPropagation();
                _this.$confirm('是否删除该歌曲?', '提示', {
                    onfirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _this.addWorkModel.music='';
                    _this.audio_name="";
                    _this.$message({
                        type: 'success',
                        message: '删除成功'
                    });
                }).catch( error =>{

                })
            },
            //上传前回调
            beforeUploadVideo(file) {
                var fileSize = file.size / 1024 / 1024 < 50;
                if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) == -1) {
                    this.$Message.error("请上传正确的视频格式");
                    return false;
                }
                if (!fileSize) {
                    this.$Message.error("视频大小不能超过50MB");
                    return false;
                }
                this.isShowUploadVideo = false;
            },
            //进度条
            uploadVideoProcess(event, file, fileList) {
                this.videoFlag = true;
                this.videoUploadPercent = file.percentage.toFixed(0) * 1;
            },
            //上传成功回调
            handleVideoSuccess(res, file) {
                this.isShowUploadVideo = true;
                this.videoFlag = false;
                this.videoUploadPercent = 0;
                if (res.code == 200) {
                    this.addWorkModel.video = res.data.video;
                    this.addWorkModel.video_cover = res.data.cover;
                    this.$Message.success('上传成功');
                }
                else {
                    this.$Message.error(res.message);
                }
            },
            delImg(index) {
                let _this = this;
                this.$confirm('确定删除这张照片?', '提示', {
                    onfirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if (_this.addWorkModel.task_id != '') {
                        _this.imgUrls.splice(index, 1);
                    }
                    else {
                        _this.imgUrls.splice(index,1);
                        _this.addWorkModel.showimages.splice(index,1);
                    }
                    _this.$message.success('删除成功!');
                }).catch(() => {
                });
            },
            delVideo() {
                let _this = this;
                this.$confirm('确定删除这个视频么?', '提示', {
                    onfirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.addWorkModel.video = ''
                    this.videoUrls = ''
                    this.addWorkModel.video_cover = ''
                    _this.$message.success('删除成功!');
                    // console.log(_this.imgUrl);
                }).catch(() => {
                });
            },
            //点击上传图片事件
            doUpload(index) {
                let _this = this;
                _this.clnum = index;
                if (index == 1) {
                    var files = document.getElementById('file1');
                    var fileLen = document.getElementById('file1').files;
                    var filename = $('#file1').val();
                    _this.option.img = URL.createObjectURL(fileLen[0]);
                    _this.cropShow = true;
                    // _this.imgd1=URL.createObjectURL(fileLen[0]);
                    $('#file1').val('')
                }
                else if (index == 3) {
                    var files = document.getElementById('file3');
                    var fileLen = document.getElementById('file3').files;
                    var filename = $('#file3').val();
                    _this.uploadByOss(fileLen[0]);
                    $('#file3').val('')
                }
                else if (index == 4) {
                    var files = document.getElementById('file4');
                    var fileLen = document.getElementById('file4').files;
                    var filename = $('#file4').val();
                    // _this.uploadByOss(fileLen[0]);
                    _this.videoUrls = URL.createObjectURL(fileLen[0]);
                    _this.getToken(fileLen[0]);
                    $('#file4').val('')
                }
                else {
                    var files = document.getElementById('file2');
                    var fileLen = document.getElementById('file2').files;
                    var filename = $('#file2').val();
                    let num = _this.imgUrls.length;
                    _this.imgUrls.push(URL.createObjectURL(fileLen[0]));
                    _this.uploadByOss(fileLen[0]);

                    $('#file2').val('')

                }
            },
            //图片地址
            upload(type) {
                let _this = this;
                _this.$refs.cropper.getCropData((dataURL) => {
                    let base64 = dataURL.split(',')[1];
                    let fileType = dataURL.split(';')[0].split(':')[1];
                    let blob = this.toBlob(base64, fileType);
                    let reader = new FileReader();
                    reader.readAsArrayBuffer(blob);
                    reader.onload = function (event) {
                        var file = new File([blob], new Date().getTime() + '.' + blob.type.split('/')[1], { type: "image/png" })
                        _this.uploadByOss(file)
                        if (_this.clnum == 1) {
                            _this.imgd1 = dataURL;
                        }
                    }

                })
            },
            //裁剪弹窗隐藏
            delCrop() {
                this.cropShow = false;
            },
            //二进制转换
            toBlob(urlData, fileType) {
                var bytes = window.atob(urlData),
                    n = bytes.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bytes.charCodeAt(n);
                }
                return new Blob([u8arr], { type: fileType });
            },
            random_string(len) {
                len = len || 32;
                var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
                var maxPos = chars.length;
                var pwd = "";
                for (var i = 0; i < len; i++) {
                    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
                }
                return pwd;
            },
            //阿里云上传
            uploadByOss(file) {
                let _this = this;
                const loading = this.$loading({
                    lock: true,
                    text: '加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var fileurl = new Date().getTime() + _this.random_string(16) + '.' + file.name.split('.')[1]
                return new Promise(function (resolve, reject) {  // Promise 一定要在函数的最外层才有效
                    _this.$axios.post('policyaction').then(function (res) {
                        var re = res.data.data;
                        var osssignature = {
                            'key': re.dir + fileurl,
                            'policy': re.policy,
                            'OSSAccessKeyId': re.accessid,
                            'success_action_status': '200',
                            'signature': re.signature,
                            'callback': re.callback,
                        };
                        var formData = new FormData()
                        for (var k in osssignature) {
                            formData.append(k, osssignature[k])
                        }
                        //var suffix = _this.get_suffix(file.type); // 获取文件扩展名
                        formData.append("key", re.dir);
                        formData.append('file', file)  // 必须放最后
                        var xhr = new XMLHttpRequest()
                        //xhr.upload.addEventListener('progress', uploadProgress, false)
                        xhr.open('POST', re.host, true)
                        xhr.send(formData)
                        xhr.onload = () => {
                            if (xhr.status === 200 || xhr.status === 304) {
                                loading.close();
                                if (_this.clnum == 1) {
                                    _this.file_url1 = xhr.responseURL + re.dir + fileurl;
                                    _this.cropShow = false;
                                }
                                else if (_this.clnum == 3) {
                                    _this.audio_name = file.name;
                                    _this.addWorkModel.music = xhr.responseURL + re.dir + fileurl;
                                }
                                else {
                                    if(_this.addWorkModel.task_id!=''){
                                        _this.imgUrlEd.push(xhr.responseURL + re.dir + fileurl);
                                    }
                                    else{
                                        _this.addWorkModel.showimages.push(xhr.responseURL + re.dir + fileurl);

                                    }
                                }
                            } else {
                                console.log(`error：error code ${xhr.status}`)
                            }
                        }
                    })
                })
            },
            //添加作业
            addWork() {
                let _this = this;
                _this.addWorkModel.task_id = '';
                _this.addWorkModel.name = '';
                _this.addWorkModel.introduction = '';
                _this.addWorkModel.showimages = [];
                _this.addWorkModel.video = '';
                _this.addWorkModel.video_cover = '';
                _this.addWorkModel.music = '';
                
                _this.valm = 0;
                _this.imgUrls = [];
                _this.videoUrls = '';
                _this.audio_name = ''
                _this.alertShow = true;
            },
            //保存作业
            saveWork(index) {
                let _this = this;
                if (_this.canpany_name == '') {
                    this.$Message.error('请输入作业名称');
                }
                else {
                    const loading = this.$loading({
                        lock: true,
                        text: '加载中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    if(_this.addWorkModel.task_id!=''){
                        let str=[],arr=[];
                        for(var i=0;i<_this.FileUrls.length;i++){
                            if(_this.FileUrls[i].indexOf('blob:http:') == -1){
                                str.push(_this.FileUrls[i]);
                            }
                        }
                        _this.FileUrls=str;
                        for(var j=0;j<_this.imgUrlEd.length;j++){
                            let show=_this.imgUrlEd[j].indexOf('blob:http:')
                            if(show == -1){
                                arr.push(_this.imgUrlEd[j]);
                            }
                        }
                        _this.imgUrlEd=arr;
                        _this.addWorkModel.showimages=_this.imgUrlEd.concat(_this.FileUrls);
                        
                    }
                    let _url = '';
                    if (index == 1) {
                        _url = 'edittask';
                    }else{
                        _url = 'addtask';
                    }
                    _this.$axios.post(_url, _this.addWorkModel).then(res => {
                            loading.close();
                            if (res.data.code == 200) {
                                _this.alertShow = false;
                                _this.getTaskList(0);
                            }
                            else {
                                this.$Message.error(res.data.message);
                            }
                        }).catch(function (error) {
                            console.log(error);
                        });
                }
            },
            tandel() {
                this.alertShow = false;
            },
            //切换舞种
            changeDance(item) {
                let _this = this;
                _this.searchModel.dance_id = item.id;
                _this.addWorkModel.dance_id = item.id;
                _this.getTaskList(1);
            },
            //切换级别
            changeLevel(item) {
                let _this = this;
                _this.searchModel.level_id      = item.id;
                _this.addWorkModel.level_id     = item.father_id;
                _this.addWorkModel.tag_level_id = item.id;
                _this.addWorkModel.tag      = item.name;
                _this.getTaskList(1);
            },
            //获取作业列表
            getTaskList(index) {
                let _this = this;
                if (index == 1) {
                    _this.searchModel.page = 1;
                }
                _this.$axios.post('gettasklist', _this.searchModel).then(res => {
                    if (res.data.code == 200) {
                        _this.data6 = res.data.data.list;
                        _this.total=res.data.data.total;
                        _this.loading = false;
                    }
                    else {
                        _this.loading = false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            updatePage(num) {
                this.searchModel.page = num;
                this.getTaskList(0);
            },
            getlevel(index) {
                let _this = this;
                _this.$axios.post('getlevellist', {is_course:1}).then(res => {
                    if (res.data.code == 200) {
                        _this.items = res.data.data;
                        _this.searchModel.level_id = res.data.data[0].id;
                        _this.addWorkModel.level_id = res.data.data[0].father_id;
                        _this.addWorkModel.tag_level_id = res.data.data[0].id;
                        _this.addWorkModel.tag = res.data.data[0].name;
                        _this.getTaskList(1);
                       
                    }
                    else {
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //获取舞种列表
            getDanceList() {
                let _this = this;
                _this.$axios.post('getdancelist', {is_course:1}).then(res => {
                    if (res.data.code == 200) {
                        _this.danceList = res.data.data;
                        if(_this.danceList.length > 0){
                            _this.searchModel.dance_id = _this.danceList[0].id;
                            _this.addWorkModel.dance_id = _this.danceList[0].id;
                        }
                        _this.getlevel(1);
                    }
                    else {
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
        },
        created() {
            let _this = this;
            _this.getDanceList(1);
        }
    }
</script>

<style scoped>
    .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
    .ivu-spin-fix{
        background-color: rgba(0,0,0,.7);
        z-index: 999;
        height: 150vh;
    }
    .ivu-spin-fix .ivu-spin-main{
        top:30%;
    }
    /*音乐*/
    .miuse_tep {
        width: 142px;
        height: 43px;
        margin-bottom: 8px;
        box-sizing: border-box;
        border: 1px solid #ffbe70;
        border-radius: 8px;
        color: #ffbe70;
        line-height: 43px;
        text-align: center;
        margin-left: 5px;
        cursor: pointer;
        position: relative;
    }
    .miuse_tit {
        margin: 0 5px;
        overflow: hidden;
        line-height: 1.2;
        padding: 13px 10px;
        width: 142px;
        height: 53px;
        border-radius: 8px;
        box-sizing: border-box;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 20px;
        /*  border:1px solid #ffbe70;
        color: #ffbe70; */ 
        text-align: center;
        cursor: pointer;
        position: relative;
        background: url(../../../static/imgs/musicicon.png) center center/40px no-repeat;
    }
    .dele_music {
        position: absolute;
        top: 0;
        right: 0;
        background: #fff url(../../../static/imgs/quxiao.png) center center no-repeat;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        /*display: none;*/
    }

    /* .miuse_tit:hover .dele_music {
        display: block;
    } */
    /**/
    .selVox {
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }

    .vue-oss-imgsrc {
        margin: 0 20px 20px 0;
        width: 150px;
        height: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        cursor: pointer;
        /*overflow: hidden;*/
    }
    .vue-oss-imgsrc:nth-child(3n){
        margin-right: 0;
    }
    .vue-oss-imgsrc img {
        display: inline-block;
        width: 100%;
        height: 100%;
    }

    .marksd {
        position: absolute;
        top: -13px;
        right: -13px;
        width: 26px;
        height: 26px;
        background: url(../../../static/imgs/delete.png) center center/26px no-repeat;
    }

    .add {
        width: 150px;
        height: 150px;
        float: left;
        cursor: pointer;
        background: url(../../../static/imgs/videoAdd.png) no-repeat;
        /*// 这里使用的是我本地图片*/
        background-size: 100% 100%;
    }

    /**/
    /* .urlLogo{
        width: 150px;
        height: 210px;
        background: #f5f5fa url('../../../static/imgs/baadd.png') center center/30px no-repeat;
        border: solid 1px #e5e5e5;
        position: relative;
        overflow: hidden;
    } */
    .urlLogo1 {
        width: 150px;
        height: 150px;
        border: solid 1px #e5e5e5;
    }

    .urlLogo input {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
    }

    .urlLogo img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        /*z-index: 999;*/
    }

    .borDiv {
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }

    .name {
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 116px;
    }

    .wzbarBox {
        /* width: 134px; */
        display: flex;
        display: -webkit-flex;
        justify-content: space-around;
        align-items: center;
        height: 61px;
    }

    .wzbar {
        color: #999;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        flex-direction: column;
        line-height: 58px;
        cursor: pointer;
        margin-right: 20px;
    }

    .wzbar>span {
        display: block;
        width: 55px;
        height: 3px;
        background-color: #f6f6f6;
    }

    .wzbars {
        color: #c30d23;
    }

    .wzbars>span {
        background-color: #c30d23;
    }

    .title {
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }

    .content,
    #manage {
        width: 100%;
    }

    .botBox {
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border: 1px solid #e6e6e6;
    }

    .center,
    .bottomBox {
        padding: 0 20px;
        box-sizing: border-box;
    }

    .top,
    .center,
    .bottom,
    .bottomBox {
        width: 100%;
    }

    .top {
        height: 62px;
        line-height: 62px;
        border-bottom: 1px solid #e6e6e6;
        /*padding: 0 20px;*/
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }

    .showBox {
        position: absolute;
        right: 20px;
        top: 65px;
        z-index: 99;
    }

    .shdawBot {
        padding: 0 30px 15px;
        box-sizing: border-box;
    }

    .addClass {
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
    .file-list{
        width: calc(100% - 132px);
    }
</style>


// WEBPACK FOOTER //
// src/view/teacher/work.vue